import { MapPin } from "lucide-react";
import project1 from "@/assets/ads-project-east-end-1.jpg";
import project2 from "@/assets/ads-project-east-end-2.jpg";
import project3 from "@/assets/ads-project-east-end-3.jpg";
import project4 from "@/assets/ads-project-east-end-4.jpg";
import project5 from "@/assets/ads-project-east-end-5.jpg";
import project6 from "@/assets/ads-project-east-end-6.jpg";

interface Project {
  image: string;
  location: string;
  caption: string;
}

const projects: Project[] = [
  {
    image: project1,
    location: "East Hampton, NY",
    caption: "GAF Timberline HDZ — Charcoal",
  },
  {
    image: project2,
    location: "Sag Harbor, NY",
    caption: "Architectural Shingles — Waterfront Home",
  },
  {
    image: project3,
    location: "Southampton, NY",
    caption: "Complete Roof Replacement",
  },
  {
    image: project4,
    location: "Montauk, NY",
    caption: "GAF Timberline UHDZ Install",
  },
  {
    image: project5,
    location: "Bridgehampton, NY",
    caption: "Premium Architectural Shingles",
  },
  {
    image: project6,
    location: "East Hampton, NY",
    caption: "GAF Timberline HDZ — Charcoal",
  },
];

export const AdsRecentProjects = () => {
  return (
    <section className="py-6 md:py-8 bg-background">
      {/* Mobile: 85% width with peek, swipeable */}
      <div className="lg:hidden pl-4 overflow-hidden">
        <div className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide gap-3 pb-4 -mr-4 pr-4">
          {projects.map((project, idx) => (
            <div
              key={idx}
              className="snap-start shrink-0 w-[85%]"
            >
              <ProjectCard project={project} />
            </div>
          ))}
        </div>
      </div>

      {/* Desktop: 4-column grid */}
      <div className="hidden lg:block container mx-auto px-4">
        <div className="grid grid-cols-4 gap-6">
          {projects.slice(0, 4).map((project, idx) => (
            <ProjectCard key={idx} project={project} />
          ))}
        </div>
        {projects.length > 4 && (
          <div className="grid grid-cols-4 gap-6 mt-6 max-w-[75%] mx-auto">
            {projects.slice(4).map((project, idx) => (
              <ProjectCard key={idx} project={project} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

const ProjectCard = ({ project }: { project: Project }) => (
  <div className="relative aspect-[9/16] rounded-2xl overflow-hidden shadow-xl group">
    <img
      src={project.image}
      alt={`Roofing project in ${project.location}`}
      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
      loading="lazy"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
    <div className="absolute bottom-0 inset-x-0 p-4 md:p-5">
      <div className="flex items-center gap-1.5 text-white/90 text-xs md:text-sm mb-1">
        <MapPin className="w-3.5 h-3.5" />
        <span className="font-semibold">{project.location}</span>
      </div>
      <p className="text-white font-bold text-base md:text-lg leading-tight">
        {project.caption}
      </p>
    </div>
  </div>
);
